import Ql from './ql'
import { getXUserKey } from '@/plugins/account'
import EasyResponse from 'easyjs/lib/Http/Response'

export const service = 'marketing'

export default {
  campaigns() {
    return Ql.query(
      service,
      `{
        campaigns {
          id
          name
          alias
          status
          run_at
          date
        }
      }`,
      { 'x-user-key': getXUserKey() }
    )
  },
  campaignByGift(gift_id) {
    return Ql.query(
      service,
      `{
        campaign (gift_id: ${gift_id}){
          id
          name
          alias
          run_at
          last_run
          status
          date
          created_at
          total_users
          total_clicks
        }
      }`,
      { 'x-user-key': getXUserKey() }
    )
  },
  campaignTargetUsers(campaign_id, term = null, page) {
    return Ql.query(
      service,
      `{
        campaignUsers(id: ${campaign_id}, term: "${term}", page: ${page}){
          name
          email
          phone
        }
      }`,
      { 'x-user-key': getXUserKey() }
    )
  },
  campaignTargetUsersClicks(campaign_id, term , page) {
    return Ql.query(
      service,
      `{
        campaignUsersClicks(id: ${campaign_id}, term: "${term}", page: ${page}){
          name
          email
          phone
        }
      }`,
      { 'x-user-key': getXUserKey() }
    )
  },
  campaign(id) {
    return Ql.query(
      service,
      `query ($id: ID) {
          campaigns (id: $id) {
            id
            name
            alias
            status
            coupon {
              type
              value
              minValue
              code
            }
            run_at
            date
            period {
              type
              days
            }
            send {
              sms {
                enabled
                template
              }
              email {
                enabled
                template
              }
              push {
                enabled
                template
              }
            }
          }
        }
      `,
      { 'x-user-key': getXUserKey() },
      {
        id: id
      }
    )
  },
  changeStatus(id, status) {
    return Ql.mutation(
      service,
      `mutation ($id: ID, $status: campaignStatus) {
        changeCampaignStatus(id:$id, status:$status)
      }`,
      { 'x-user-key': getXUserKey() },
      {
        id: id,
        status: status
      }
    )
  },
  addCampaign(campaign) {
    const func = campaign.id ? 'updateCampaign' : 'addCampaign'
    return Ql.mutation(
      service,
      `mutation ($campaign: CampaignInput!) {
        ${func}(campaign: $campaign) {
          id
        }
      }
      `,
      { 'x-user-key': getXUserKey() },
      { campaign }
    )
  },
  sendSimulation(simulation) {
    return Ql.mutation(
      service,
      `mutation ($simulation: SimulationCampaignInput!) {
        simulateCampaign(simulation: $simulation) {
          name
        }
      }
      `,
      { 'x-user-key': getXUserKey() },
      { simulation }
    )
  },
  campaignTemplate(alias) {
    return Ql.query(
      service,
      `query($alias: campaignType!) {
        campaignStrings(alias: $alias) {
          sms
          email
          push
        }
      }`,
      { 'x-user-key': getXUserKey() },
      { alias }
    )
  }
  // updateCampaign (campaign) {
  //   return Ql.mutation(
  //     service,
  //     `mutation ($)`
  //   )
  // }
}
